export default function (text) {
    return text.split(" ").splice(0,7).join(" ") + ' ...'
}
